import { componentStyle } from '@/styling/util/component-style.ts';
import type { GalleriaDesignTokens } from '@primeuix/themes/types/galleria';

export const galleriaStyle = componentStyle<GalleriaDesignTokens>({
    root: {
        borderWidth: '0',
    },
    thumbnailsContent: {
        background: '{ color.backgroundBluegray }',
    },
    navButton: {
        color: '{ primary.500 }',
        hoverColor: '{ primary.600 }',
    },
    navIcon: {
        size: '2rem',
    },
});
